// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"218":"component---src-pages-404-tsx","691":"component---src-pages-index-tsx"}[chunkId] || chunkId) + "-" + {"218":"e12d4c50353b68c3d013","589":"ee1a1d0f9f95f4945f1f","691":"edebfc0d33a000a817dd"}[chunkId] + ".js";
};